export default {
  // 黑名单标签
  usdtBlocked: "# USDT BLOCKED",
  usdcBlocked: "# USDC BLOCKED",

  // 地址信息
  availableBalance: "地址可用余额",
  inOutTransactions: "转入&转出笔数(USDT)",
  inOutCounterparties: "转入&转出对手数(USDT)",
  cumulativeInOutAmount: "累计转入&转出数量(USDT)",
  avgInOutAmount: "平均转入&转出数量(USDT)",
  creator: "创建者",
  createdAt: "创建于",
  addressNote: "地址备注",
};
